import { render } from "./botDelays.vue?vue&type=template&id=0c9dc177"
import script from "./botDelays.vue?vue&type=script&lang=js"
export * from "./botDelays.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__